module.exports = __webpack_public_path__ + "img/mute_speaker_b.f20b53e1.svg";